const SideBarState = {
  SPIN: "SPIN",
  SHOW: "SHOW",
  HIDE: "HIDE"
};
export default SideBarState;
